import React from 'react'

const TermsAndConditions = () => {
  return (
    <div>TermAndCondition</div>
  )
}

export default TermsAndConditions;